import React from 'react'
import { toast } from 'react-toastify'
import IconCircleCheck from 'assets/svg/icon-circle-check.svg?react'
import IconCircleError from 'assets/svg/icon-circle-error.svg?react'
import IconCircleInfo from 'assets/svg/icon-circle-info.svg?react'
import IconWarning from 'assets/svg/icon-warning.svg?react'
import IconNotificationsOff from 'assets/svg/icon-notifications-off.svg?react'
import IconNotificationsActive from 'assets/svg/icon-notifications-active.svg?react'
import { Link } from 'react-router-dom'

export const toastrSuccess = (title: string, description: string) => {
  const options: any = {
    autoClose: 5000,
    icon: () => <IconCircleCheck />,
  }
  return toast.success(
    <>
      <h1>{title}</h1>
      <p>{description}</p>
    </>,
    options
  )
}

export const toastrError = (title: string, description: any) => {
  const options: any = {
    autoClose: 5000,
    icon: () => <IconCircleError />,
  }
  return toast.error(
    <>
      <h1>{title}</h1>
      <p>{description}</p>
    </>,
    options
  )
}

export const toastrWarning = (title: string, description: string) => {
  const options: any = {
    autoClose: 5000,
    icon: () => <IconWarning />,
  }
  return toast.warning(
    <>
      <h1>{title}</h1>
      <p>{description}</p>
    </>,
    options
  )
}

export const toastrInfo = (title: string, description: string) => {
  const options: any = {
    autoClose: 5000,
    icon: () => <IconCircleInfo />,
  }
  return toast.info(
    <>
      <h1>{title}</h1>
      <p>{description}</p>
    </>,
    options
  )
}

export const toastrAlarmError = (title: string, description: any) => {
  const options: any = {
    autoClose: 5000,
    icon: () => (
      <Link to='/alarms' className='toastr-alarm-error-icon'>
        <IconNotificationsActive />
      </Link>
    ),
  }
  return toast.error(
    <Link to='/alarms'>
      <h1>{title}</h1>
      <p>{description}</p>
    </Link>,
    options
  )
}

export const toastrAlarmSuccess = (title: string, description: any) => {
  const options: any = {
    autoClose: 5000,
    icon: () => <IconNotificationsOff />,
  }
  return toast.success(
    <>
      <h1>{title}</h1>
      <p>{description}</p>
    </>,
    options
  )
}
